<template>
  <div class="instagram-tile">
    <img :src="tile.imageUrl" class="instagram-tile__image" />
    <a v-if="tile.linkUrl" :href="tile.linkUrl" class="instagram-tile__link"
      >Shop the look</a
    >
  </div>
</template>

<script>
export default {
  name: "InstagramTile",
  props: {
    tile: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.instagram-tile {
  position: relative;
}

.instagram-tile__image {
  max-width: 100%;
  width: 100%;
}

.instagram-tile__link {
  bottom: 10px;
  color: rgb(255, 255, 255);
  font-size: 9px;
  font-weight: 600;
  left: 10px;
  letter-spacing: 0.49px;
  line-height: 12px;
  position: absolute;
  text-transform: uppercase;
  text-decoration: none;

  @include respond-above(md) {
    bottom: 12px;
    left: 10px;
    line-height: 14px;
  }
}
</style>
